<template>
  <div class="tab">
    <main class="page_container">
      <el-table
        :data="items"
        :span-method="getSpanMethod"
        :row-class-name="getRowClasses"
        :row-key="row_key"
        :expand-row-keys="expandRowKeys"
        @expand-change="handleExpandChange"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <massive-reserve-transfer-list
              v-if="scope.row.type === 'massive'"
              :data="scope.row.groups"
              :server-id="server.id"
              :go-to-server-page="goToServerPage"
              :go-to-report-in-admin-lk="goToReportInAdminLk"
              :is-return-button-loading="isReturnButtonLoading"
              :handle-return-cameras-button="handleReturnCamerasButton"
            />
            <massive-reserve-from-one-server-list
              v-else
              :data="scope.row.groups[0].transfers"
              :server-id="server.id"
              :go-to-server-page="goToServerPage"
              :go-to-report-in-admin-lk="goToReportInAdminLk"
              :is-return-button-loading="isReturnButtonLoading"
              :handle-return-cameras-button="handleReturnCamerasButton"
            />
          </template>
        </el-table-column>
        <el-table-column label="Сервер" prop="server_name_from">
          <template slot-scope="scope">
            <template
              v-if="scope.row.type === 'single'"
            >
              <el-tooltip
                v-if="scope.row.groups[0].server_from.id !== server.id"
                content="Перейти в страницу сервера"
                :open-delay="1000"
              >
                <el-link
                  type="primary"
                  @click="goToServerPage(scope.row.groups[0].server_from.id, scope.row.groups[0].server_from.id_operator)"
                  class="link"
                >
                  {{ scope.row.groups[0].server_from.name }}
                </el-link>
              </el-tooltip>
              <template v-else>
                {{ scope.row.groups[0].server_from.name }}
              </template>
            </template>
            <template v-else>
              <b>МАССОВОЕ РЕЗЕРВИРОВАНИЕ</b>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Резервный сервер" prop="server_name_to">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.type === 'single' && scope.row.groups[0].transfers[0].server_to.id !== server.id"
              content="Перейти на страницу сервера"
              :open-delay="1000"
            >
              <el-link
                type="primary"
                @click="goToServerPage(scope.row.groups[0].transfers[0].server_to.id, scope.row.groups[0].transfers[0].server_to.id_operator)"
                class="link"
              >
                {{ scope.row.groups[0].transfers[0].server_to.name }}
              </el-link>
            </el-tooltip>
            <template v-else>
              {{ scope.row.groups[0].transfers[0].server_to.name }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Статус" prop="status_description">
          <template slot-scope="scope">
            <template v-if="scope.row.type === 'massive'">
              {{ scope.row.status_description || 'Нет данных' }}
            </template>
            <template v-else>
              <el-tooltip
                v-if="scope.row.groups[0].transfers[0].is_report_accessible === 1"
                content="Перейти в ЛК администратора"
                :open-delay="1000"
              >
                <el-link
                  type="primary"
                  class="link"
                  @click="goToReportInAdminLk(scope.row.groups[0].transfers[0].id_reserve_transfer)"
                >
                  {{ scope.row.groups[0].transfers[0].status_description }}
                </el-link>
              </el-tooltip>
              <template v-else>
                {{ scope.row.groups[0].transfers[0].status_description }}
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Дата/время" prop="start_date">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 'single'">{{ scope.row.groups[0].transfers[0].start_dt }}</span>
            <template v-else>
              <span>{{ scope.row.start_date }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.type === 'single' && scope.row.groups[0].transfers[0].status !== 11"
              class="return_button"
              size="small"
              type="primary"
              :loading="isReturnButtonLoading"
              @click="() => handleReturnCamerasButton(scope.row.groups[0].transfers[0])"
            >
              Вернуть камеры на свой сервер
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="list__pagination"
        layout="prev, pager, next"
        :page-size="count"
        :total="total"
        :current-page="page"
        @current-change="handleChangePage"
      />
      <return-cameras-dialog
        :id-transfer="dialogReturnCamerasIdTransfer"
        :visible="dialogReturnCameras"
        :messageText="dialogReturnCamerasMessageText"
        confirm-button-text="Вернуть камеры"
        @close="onDialogReturnCamerasClose"
        @save="handleReturnCamerasConfirm"
      />
    </main>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import isUndefined from "lodash/isUndefined";
import OperatorService from "@/api/services/operator.service";
import MassiveReserveTransferList from "./MassiveReserveTransferList";
import MassiveReserveFromOneServerList from "./MassiveReserveFromOneServerList";
import ReturnCamerasDialog from "../../feature/ReturnCamerasDialog.vue"

export default {
  name: "ReserveTransfersList",
  components: { MassiveReserveTransferList, MassiveReserveFromOneServerList, ReturnCamerasDialog },
  data() {
    return {
      loading: false,
      isReturnButtonLoading: false,
      dialogReturnCameras: false,
      dialogReturnCamerasIdTransfer: 0,
      dialogReturnCamerasMessageText: null,
      expandRowKeys: [],
      page: 1,
    }
  },
  computed: {
    ...mapState("server", {
      server: (state) => state.server,
      items: (state) => state.reserveTransfers.data,
      total: (state) => state.reserveTransfers.total,
      count: (state) => state.reserveTransfers.count,
    }),
  },
  watch: {
    server() {
      this.getList()
    },
  },
  created() {
    this.setList({
      data: [],
      total: 0,
      count: 50,
    });

    this.loading = true;
    this.getList().then(() => (this.loading = false));
    this.intervalId = setInterval(() => {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
      this.getList();
    }, 8000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    ...mapActions("server", {
      getServerReserveTransfersList: "GET_SERVER_RESERVE_TRANSFERS",
      returnCameras: "RETURN_CAMERAS",
    }),
    ...mapMutations("server", {
      setList: "SET_RESERVE_TRANSFERS",
    }),
    getList() {
      if (!isUndefined(this.server.id)) {
        return this.getServerReserveTransfersList({
          id: this.server.id,
          headers: {
            page: this.page,
            count: this.count,
          }
        });
      }
      else
        return new Promise(() => {});
    },
    goToServerPage(idServer, idOperator) {
      OperatorService.setOperatorId(idOperator);
      const url = `/servers/edit/${idServer}`;
      window.open(url, "_blank");
    },
    goToReportInAdminLk(id) {
      const url = `${process.env.VUE_APP_LK_ADMIN_DOMAIN}/reserve-transfers-report/${id}`;
      window.open(url, "_blank");
    },
    handleReturnCamerasButton(reserveTransfer) {
      this.dialogReturnCameras = true;
      this.dialogReturnCamerasIdTransfer = reserveTransfer.id_reserve_transfer;
      this.dialogReturnCamerasMessageText = `Вернуть камеры с сервера ${reserveTransfer.server_to.name}
          на сервер ${reserveTransfer.server_from.name}?`
    },
    handleReturnCamerasConfirm(transferId, force) {
      this.isReturnButtonLoading = true;

      this.returnCameras({ id: transferId, force: force })
        .then(() => {
          this.$message({
            message: "Камеры возвращены",
            type: "success",
          });
          this.getList({
            page: this.page,
            count: this.count,
            return_status: this.isArchive ? 1 : 0,
          });
        })
        .catch((e) => {
          if (e !== "cancel") {
            this.$message({
              type: "error",
              message: e?.response?.data.error || "Неизвестная ошибка",
            });
          }
        })
        .finally(() => {
          this.isReturnButtonLoading = false;
          this.dialogReturnCameras = false;
          this.dialogReturnCamerasIdTransfer = 0;
          this.dialogReturnCamerasMessageText = null;
        });
    },
    onDialogReturnCamerasClose() {
      this.dialogReturnCameras = false;
      this.dialogReturnCamerasIdTransfer = 0;
      this.dialogReturnCamerasMessageText = null;
    },
    getSpanMethod({ row, columnIndex }) {
      if (row.type === "massive") {
        if (columnIndex === 1) {
          return [1, 2];
        } else if (columnIndex === 2) {
          return [0, 0];
        }
      }
    },
    getRowClasses ({ row }) {
      return row.type === 'single' && row.groups[0].transfers.length === 1 ? 'no-expand' : null
    },
    row_key(row) {
      return row.id_report
    },
    handleExpandChange(row) {
      const id = row.id_report
      const indexExpandedRow = this.expandRowKeys.findIndex((idExpanded) => id === idExpanded)
      if (indexExpandedRow !== -1) {
        this.expandRowKeys.splice(indexExpandedRow, 1)
      } else {
        this.expandRowKeys.push(id)
      }
    },
    handleChangePage(page) {
      this.expandRowKeys = [];
      this.page = page;
      this.getList();
    },
  }
}
</script>

<style>
.link {
  line-height: 1;
  text-decoration: underline;
  cursor: pointer;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  color: #409eff;
}
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
.no-expand .el-icon {
  display: none;
}
.no-expand .el-table__expand-icon {
  pointer-events: none;
}
.return_button {
  text-wrap: wrap;
  width: 125px;
}
</style>
